const sexOptions = [{ label: 'Mujer', value: 'mujer' }, 
{ label: 'Hombre', value: 'hombre' }]
export default sexOptions